function UploadIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='56'
      height='56'
      fill='none'
      viewBox='0 0 61 60'
      style={{ margin: '12px 0' }}
    >
      <rect width='60' height='60' x='0.5' fill='#06F' rx='30' />
      <path
        fill='#fff'
        d='M26.72 24.28a.75.75 0 010-1.061l3-3a.75.75 0 01.817-.162.749.749 0 01.244.162l3 3a.75.75 0 01-1.06 1.061L31 22.56v11.19a.75.75 0 01-1.5 0V22.561l-1.72 1.72a.751.751 0 01-1.061-.001zM36.25 27a.75.75 0 000 1.5c1.577 0 2.25.673 2.25 2.25v5c0 1.577-.673 2.25-2.25 2.25h-12c-1.577 0-2.25-.673-2.25-2.25v-5c0-1.577.673-2.25 2.25-2.25a.75.75 0 000-1.5c-2.418 0-3.75 1.332-3.75 3.75v5c0 2.418 1.332 3.75 3.75 3.75h12c2.418 0 3.75-1.332 3.75-3.75v-5c0-2.418-1.332-3.75-3.75-3.75z'
      />
    </svg>
  );
}

export default UploadIcon;
